module.exports = __webpack_public_path__ + "static/media/discard.9f4fbc81.png";